import { ReactNode } from "react";

interface CardProps {
  title?: string;
  children?: ReactNode;
  className?: string;
  subtitle?: string;
  icon?: ReactNode;
}

function Card({ title, children, className, subtitle, icon }: CardProps) {
  return (
    <div
      className={
        "rounded-2xl border border-gray-200 bg-white p-4 shadow-theme-sm dark:border-gray-800 dark:bg-gray-900 sm:w-full md:w-full lg:w-1/3 " +
        (className ?? "")
      }
    >
      <h5 className="text-xl font-bold select-none flex items-center gap-2 text-gray-900 dark:text-white/90">
        {icon}
        {title}
        {subtitle ? (
          <span className="text-xs font-light text-gray-500 dark:text-gray-400">{subtitle}</span>
        ) : null}
      </h5>

      <div className="mt-4">{children}</div>
    </div>
  );
}

export default Card;
